import React from "react";
import ReactModal from "react-modal";
import { useDispatch, useSelector } from 'react-redux';

import { getModalData, isModalActive, closeModal } from "../../store/slices/modal";

import { ConfirmationView } from "../views/modals/Message";

import { IMessageModalData } from "../../interfaces/modals";

import { SVGIcon } from "../wrappers/SVGIcon";

import { Icons } from "../../data/Assets";

const modalName = "MESSAGE_MODAL";
const modalTitle = "Message";
const modalClass = "message";

ReactModal.setAppElement('#root');
const MessageModal = () => {
    const dispatch = useDispatch();

    const isModalVisible: boolean = useSelector(isModalActive(modalName));
    const modalData: IMessageModalData | null = useSelector(getModalData(modalName));
    const { closeOnEsc = true, closeOnOutsideClick = true, closeBtn = true, view } = modalData || {};

    const afterOpenModal = () => { };

    const onCloseModal = () => {
        dispatch(closeModal(modalName));
    };

    return (
        <ReactModal
            id={modalName}
            isOpen={isModalVisible && !!modalData}
            onAfterOpen={afterOpenModal}
            onRequestClose={onCloseModal}
            contentLabel={modalTitle}
            overlayClassName={`immersion_admin__modal_overlay immersion_admin__modal_overlay__${modalClass}`}
            className={`immersion_admin__modal_dialog immersion_admin__modal_dialog__${modalClass}`}
            shouldCloseOnEsc={closeOnEsc}
            shouldCloseOnOverlayClick={closeOnOutsideClick}
        >
            <div className={`immersion_admin__modal_content immersion_admin__modal_content__${modalClass}`}>
                {closeBtn &&
                    <button className="immersion_admin__modal_close_btn" onClick={onCloseModal}>
                        <SVGIcon src={Icons.X} />
                    </button>
                }
                {view === "CONFIRMATION" &&
                    <ConfirmationView
                        title={modalData?.title ?? ""}
                        content={modalData?.content ?? ""}
                        action={() => modalData?.action ? modalData?.action() : null}
                        actionTxt={modalData?.actionTxt ?? ""}
                        onClose={onCloseModal}
                        cancelFn={() => modalData?.cancelFn ? modalData?.cancelFn() : null}
                        cancelTxt={modalData?.cancelTxt ?? "Cancel"}
                    />
                }
            </div>
        </ReactModal>
    );
};

export default MessageModal;